'use client';

// FIX: This is a app component, shouldn't be on the ui library
import * as React from 'react';

import { Clock20Regular, Doctor20Regular } from '@fluentui/react-icons';
import { format } from 'date-fns';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

import { Surface } from '../../atoms/surface';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../atoms/tooltip';

const appointmentCardVariants = tv({
  base: 'flex justify-center items-center h-full w-full',
});

//Waiting on loading state design, telehealth design, and potential avatar group for attendees
export type AppointmentCardProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof appointmentCardVariants> & {
    header: React.ReactElement;
    appointmentType: {
      name: string;
      method: string;
    };
    startAt: Date;
    patient: {
      firstName: string;
      lastName: string;
      gender: string;
      dateOfBirth: string | Date;
    };
    provider?: {
      firstName: string;
      lastName: string;
      avatar: string | null;
    } | null;
    timeInSession?: string;
    formatedDOB: string;
    onActionButtonClick?: () => void;
  };

export const AppointmentCard = React.forwardRef<
  HTMLDivElement,
  AppointmentCardProps
>(({ className, header, ...props }, ref) => {
  const patientDOB = new Date(props.patient.dateOfBirth);
  const patientName = `${props.patient.lastName.trim()},  ${
    props.patient.firstName
  }`;
  return (
    <div
      className={cn(
        appointmentCardVariants({
          className,
        }),
      )}
      ref={ref}
      {...props}
    >
      <Surface elevation={0} className="h-[10.75rem] items-start">
        <div className="flex w-60 flex-col gap-y-2 p-5">
          <section className="text-title-4 flex items-center justify-between gap-x-2">
            <div
              className={cn(
                'text-primary-500 flex items-center justify-between gap-2',
              )}
            >
              {header}
            </div>
          </section>
          <section className="relative flex flex-col gap-y-2">
            <div className="flex flex-col gap-y-1 text-gray-900">
              <Tooltip>
                <TooltipTrigger className="text-title-3 w-full truncate whitespace-nowrap text-left font-semibold">
                  {patientName}
                </TooltipTrigger>
                <TooltipContent alignOffset={-100} sideOffset={0}>
                  {patientName}
                </TooltipContent>
              </Tooltip>
              <div className="text-body-4">
                <span>{props.formatedDOB}</span>
                {' • '}
                <span>{props.patient.gender.charAt(0).toUpperCase()}</span>
                {' • '}
                <span>{format(patientDOB, 'MMM dd, yyyy')}</span>
              </div>
            </div>
            <div className="flex items-center gap-x-1" data-dd-privacy="allow">
              <Clock20Regular className="text-primary-500" />
              <span className="text-body-4 text-gray-500">
                {format(props.startAt, 'h:mm a')}
              </span>
            </div>
            {props.provider && (
              <div className="text-body-4 flex items-center gap-x-1 text-gray-500">
                <Doctor20Regular className="text-primary" />
                <div>
                  {props.provider.firstName} {props.provider.lastName}
                </div>
              </div>
            )}
          </section>
        </div>
      </Surface>
    </div>
  );
});

AppointmentCard.displayName = 'AppointmentCard';
